export default function IconFacebook({ className }: { className?: string }) {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <g clipPath='url(#clip0_1020_11798)'>
        <circle cx='12' cy='12' r='10.5' fill='#1878F3' />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M9.4917 22.1985V14.7221H6.75V11.6201H9.4917V9.33776C9.4917 6.69153 11.1476 5.25006 13.577 5.25006C14.3957 5.2482 15.2139 5.2883 16.0282 5.37018V8.14006H14.3396C13.0178 8.14006 12.7599 8.74774 12.7599 9.64513V11.6201H15.9192L15.5089 14.7221H12.7599V22.4729C12.509 22.4909 12.2555 22.5 12 22.5C11.1355 22.5 10.2954 22.3955 9.4917 22.1985Z'
          fill='white'
        />
      </g>
      <defs>
        <clipPath id='clip0_1020_11798'>
          <rect
            width='21'
            height='21'
            fill='white'
            transform='translate(1.5 1.5)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}
